import React from 'react';
import { FadeIn } from './FadeIn';
import { GiftIcon, TimerIcon, TargetIcon, ZapIcon, BarChart2Icon, BrainIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    icon: <TimerIcon className="w-6 h-6" data-id="element-15" />,
    label: 'Bono 1',
    title: 'Protocolo Sub-10',
    desc: 'El sistema para bajar entre 5 y 10 minutos el tiempo HYROX sin entrenar más horas. Pacing, transiciones, gestión de estaciones y estrategia de competencia. El bono que más rápido cambia el rendimiento real.'
  }, {
    icon: <ZapIcon className="w-6 h-6" data-id="element-16" />,
    label: 'Bono 2',
    title: 'HYROX Engine',
    desc: 'El sistema de resistencia específica para no explotar en el kilómetro 5. Cómo construir el motor que permite sostener ritmo, recuperar entre estaciones y llegar fuerte a la segunda mitad de la carrera.'
  }, {
    icon: <TargetIcon className="w-6 h-6" data-id="element-17" />,
    label: 'Bono 3',
    title: 'Las 8 Estaciones Sin Puntos Débiles',
    desc: 'Cómo detectar, corregir y mejorar la estación que más tiempo, energía y confianza le roba al atleta. Mini protocolos de mejora para cada una de las 8 estaciones HYROX.'
  }, {
    icon: <BrainIcon className="w-6 h-6" data-id="element-18" />,
    label: 'Bono 4',
    title: 'Transiciones de Élite',
    desc: 'El sistema para pasar del running a la estación sin destruir el ritmo, la técnica ni la cabeza. Errores más comunes de entrada y salida, respiración táctica y cómo entrenar transiciones de forma específica.'
  }, {
    icon: <BarChart2Icon className="w-6 h-6" data-id="element-19" />,
    label: 'Bono 5',
    title: 'Race Strategy HYROX',
    desc: 'El mapa completo para competir con inteligencia, regular el esfuerzo y ejecutar una carrera HYROX como alguien que sabe exactamente lo que está haciendo. Estrategia por nivel, por estación y por bloque mental.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-hyrox-surface" data-id="element-20">
      <div className="max-w-6xl mx-auto" data-id="element-21">
        <FadeIn data-id="element-22">
          <div className="text-center mb-16" data-id="element-23">
            <div className="inline-flex items-center justify-center gap-2 bg-hyrox-orange/10 text-hyrox-orange px-4 py-2 rounded-full font-bold mb-6 border border-hyrox-orange/20" data-id="element-24">
              <GiftIcon className="w-5 h-5" data-id="element-25" />
              <span data-id="element-26">5 BONOS DE ALTO RENDIMIENTO</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-display font-bold text-white max-w-3xl mx-auto" data-id="element-27">
              Y además de los 6 tomos, recibís 5 bonos diseñados para que cada
              uno solo ya valga el precio del pack completo.
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-28">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-29">
              <div className="bg-hyrox-dark border border-hyrox-muted p-6 sm:p-8 rounded-2xl h-full flex flex-col hover:border-hyrox-orange/30 transition-colors" data-id="element-30">
                <div className="flex items-center gap-3 mb-4" data-id="element-31">
                  <div className="bg-hyrox-surface w-12 h-12 rounded-full flex items-center justify-center text-hyrox-orange border border-hyrox-muted shrink-0" data-id="element-32">
                    {bonus.icon}
                  </div>
                  <span className="text-hyrox-orange font-bold text-xs uppercase tracking-widest" data-id="element-33">
                    {bonus.label}
                  </span>
                </div>
                <h3 className="text-xl font-display font-bold text-white mb-3" data-id="element-34">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 leading-relaxed flex-grow" data-id="element-35">
                  {bonus.desc}
                </p>
              </div>
            </FadeIn>)}
          {/* Empty div for grid alignment on lg */}
          <div className="hidden lg:block" data-id="element-36" />
        </div>
      </div>
    </section>;
}